 const E_BET = 'ꀔꀀꀁꀃꀄꀅꀆꀇꀈꀉꀊꀋꀌꀍꀎꀏꀐꀑꀒꀓꀔ'

function GenerateKey() {
    let ALLOWED = E_BET
    let length = 11, str = ''
    for (let i = 0; i < length; i++) {
        let rand_id = Math.random() * (ALLOWED.length - 0) + 0;
        let char = ALLOWED.charAt(rand_id)
        str+=char
        ALLOWED = ALLOWED.replace(char,'');
    }
    return str
}

export function Magicalizer (data, MAGIC = GenerateKey()) {
    let value = data.split('')
    let string = []
    for (let [index, symbol] of value.entries()) {
        let code = symbol.charCodeAt(0)
        code = code.toString().split('')
        for (let pos of code) {
            string.push(MAGIC[parseInt(pos)])
        }
        if (index < value.length-1) string.push(MAGIC[10])
    }
    return `${string.join('')}:${MAGIC}`
}

export function Demagicalizer (data) {
    data = data.replaceAll('\n', '')
    let [encrypted, key] = data.split(':')
    let chars = encrypted.split(key[10])
    let ret = []
    for (let symb of chars) {
        let arr = symb.split('')
        let code = []
        for (let letter of arr) {
            code.push(key.indexOf(letter))
        }
        code = code.join('')
        ret.push(String.fromCharCode(parseInt(code)))
    }
    ret = ret.join('')
    console.log(ret)
    return ret
}

 export function UUID() {
     var d = new Date().getTime();//Timestamp
     var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
         var r = Math.random() * 16;//random number between 0 and 16
         if(d > 0){//Use timestamp until depleted
             r = (d + r)%16 | 0;
             d = Math.floor(d/16);
         } else {//Use microseconds since page-load if supported
             r = (d2 + r)%16 | 0;
             d2 = Math.floor(d2/16);
         }
         return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
     });
 }
